module.exports = __webpack_public_path__ + "static/media/about-woman-1.a794af22.jpg";